import type { SVGProps } from 'react';

const ImageCountMonitorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <ellipse cx="30" cy="30" rx="30" ry="30" fill="currentColor" />
    <path
      d="M39.9997 17H19C17.3431 17 16 18.3431 16 20V40.9997C16 42.6565 17.3431 43.9997 19 43.9997H39.9997C41.6565 43.9997 42.9997 42.6565 42.9997 40.9997V20C42.9997 18.3431 41.6565 17 39.9997 17Z"
      stroke="#2563EB"
      strokeWidth="1.6875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.2496 27.4985C25.4922 27.4985 26.4996 26.4911 26.4996 25.2485C26.4996 24.0059 25.4922 22.9985 24.2496 22.9985C23.007 22.9985 21.9996 24.0059 21.9996 25.2485C21.9996 26.4911 23.007 27.4985 24.2496 27.4985Z"
      stroke="#2563EB"
      strokeWidth="1.6875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.0001 34.9984L35.5002 27.4985L19.0004 43.9983"
      stroke="#2563EB"
      strokeWidth="1.6875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ImageCountMonitorIcon;
